import * as Sentry from "@sentry/react";
import { useMutation } from "@tanstack/react-query";

import { SUBMIT_APPLICATION_STORE_KEY } from "@krea/customer-features/store/queryClient";

import { submitApplication } from "@/services/api/loan-application/actions";

export const useSubmitApplication = () => {
  return useMutation({
    mutationKey: [SUBMIT_APPLICATION_STORE_KEY],

    mutationFn: submitApplication,

    onError: (err) => {
      console.error("Failed submitting application data", err);
      Sentry.captureException(err);
    },
  });
};
